import React, { useEffect, useRef, useState } from 'react';
import { MapPin } from 'lucide-react';
import { base44 } from '@/api/base44Client';

const EMBED_SRC = 'https://maps.google.com/maps?q=Ikonomakis%20Hair%20Atelier%2C%20%CE%97%CF%81%CE%B1%CE%BA%CE%BB%CE%B5%CE%AF%CF%84%CE%BF%CF%85%2080%2C%20%CE%A7%CE%B1%CE%BB%CE%AC%CE%BD%CE%B4%CF%81%CE%B9%2015238&z=16&hl=el&output=embed';
const DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1&destination=Ikonomakis+Hair+Atelier,+%CE%97%CF%81%CE%B1%CE%BA%CE%BB%CE%B5%CE%AF%CF%84%CE%BF%CF%85+80,+%CE%A7%CE%B1%CE%BB%CE%AC%CE%BD%CE%B4%CF%81%CE%B9';
const MAPS_URL = 'https://maps.google.com/?cid=12636249697448403693';

const LABELS = {
  el: { show: 'Εμφάνιση χάρτη', dir: 'Οδηγίες', open: 'Άνοιγμα στο Google Maps', note: "Parking στον δρόμο, κοντά στο atelier · 15' από το Μετρό Χαλανδρίου", address: 'Ηρακλείτου 80, Χαλάνδρι 15238' },
  en: { show: 'Show map', dir: 'Directions', open: 'Open in Google Maps', note: 'Street parking nearby · 15 min walk from Chalandri Metro', address: 'Irakleitou 80, Chalandri 15238' },
};

const hasConsent = () => { try { return localStorage.getItem('cookie_consent') === 'granted'; } catch { return false; } };

export default function AtelierMap({ lang = 'el', className = '' }) {
  const t = LABELS[lang] || LABELS.el;
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (loaded || !hasConsent() || !ref.current) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setLoaded(true); io.disconnect(); } }, { rootMargin: '200px' });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [loaded]);

  const trackDirections = () => base44.analytics.track({ eventName: 'directions_click', properties: { page_url: window.location.pathname } });

  return (
    <div className={className}>
      <div ref={ref} className="relative h-[320px] md:h-[420px] rounded-card-xl overflow-hidden border border-brown/10 bg-cream-soft">
        {loaded ? (
          <iframe
            title="Χάρτης – Ikonomakis Hair Atelier, Ηρακλείτου 80, Χαλάνδρι"
            src={EMBED_SRC}
            width="100%"
            height="100%"
            className="absolute inset-0 w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center">
            <div className="w-14 h-14 rounded-full bg-gold/15 flex items-center justify-center text-gold"><MapPin className="w-6 h-6" /></div>
            <p className="font-serif text-h3 text-warm-black">{t.address}</p>
            <button type="button" onClick={() => setLoaded(true)} className="px-6 py-3 rounded-pill bg-warm-black text-cream text-body-s font-medium hover:bg-brown transition-colors">
              {t.show}
            </button>
          </div>
        )}
      </div>
      <div className="mt-4 flex flex-wrap gap-3">
        <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" onClick={trackDirections} className="inline-flex items-center px-6 py-3 rounded-pill bg-warm-black text-cream text-body-s font-medium hover:bg-brown transition-colors">
          {t.dir} →
        </a>
        <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 rounded-pill border border-warm-black/30 text-warm-black text-body-s font-medium hover:border-gold hover:text-gold transition-colors">
          {t.open}
        </a>
      </div>
      <p className="mt-3 text-body-s text-muted">{t.note}</p>
    </div>
  );
}